import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  updateAccountPlayerEngagement,
  updateAccountPlayerInteractivity,
  updateAccountPlayerPlays,
  updateAccountPlayerFreePlays
} from 'actions/partner';
import AccountPlayerChart from 'components/accountplayer/AccountPlayerChart';

const mapStateToProps = (state) => {
  return {
    accountPlayer: state.accountPlayer.player,
    data: {
      id: get(state.accountPlayer, 'player.id', 0),
      engagement: state.accountPlayer.engagement,
      interactivity: state.accountPlayer.interactivity,
      periods: state.accountPlayer.periods,
      plays: state.accountPlayer.plays,
      freePlays: state.accountPlayer.freePlays,
      uploads: state.accountPlayer.uploads,
    },
    meta: state.meta.accountPlayer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateEngagement: (id, params) => {
      dispatch(updateAccountPlayerEngagement(id, params));
    },
    onUpdateInteractivity: (id, params) => {
      dispatch(updateAccountPlayerInteractivity(id, params));
    },
    onPlaysPageChange: (id, page) => {
      dispatch(updateAccountPlayerPlays(id, {page}));
    },
    onPlaysSortChange: (id, sort, order) => {
      dispatch(updateAccountPlayerPlays(id, {sort, order}));
    },
    onFreePlaysPageChange: (id, page) => {
      dispatch(updateAccountPlayerFreePlays(id, {page}));
    },
    onFreePlaysSortChange: (id, sort, order) => {
      dispatch(updateAccountPlayerFreePlays(id, {sort, order}));
    },
  };
};

const AccountPlayerChartsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountPlayerChart);

export default AccountPlayerChartsContainer;
